import React from 'react';
import FieldSelectAutoComplete from '../../configuration/fields/FieldSelectAutoComplete';
import * as Helper from '../IndexHelpers';

export default class IndexTableFiltersPanelMultiSelect extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    static getInputStateValue = (filter) => {


        if (filter.values.selectedItems !== null && filter.values.selectedItems.length > 0) {

            return {
                type: filter.meta.type,
                value: filter.values.selectedItems.map(x => x.value)
            }
        }
        return null;

    }

    static fillQueries = (filter, queries) => {

        if (filter.values.selectedItems !== null && filter.values.selectedItems.length > 0) {
            filter.values.selectedItems.forEach(element => {
                let item = filter.values.items.find(x => x.value == element.value);
                let itemIndex = filter.values.items.indexOf(item);
                queries.push({

                    label: filter.meta.name + ': ' + item.text,
                    slug: filter.meta.slug,
                    value: item.value,
                    index: itemIndex,
                    type: Helper.getPropType(filter),
                    color: Helper.getFilterColor()

                });
            });

        }
        return queries;

    }

    onChange = item => {
        let items = this.getItems();
        let selectedItem = items.find(x => x.value === item);

        // let values= props.value||  [];
        // values.push(item);
        let index = items.indexOf(selectedItem);
        this.props.onChange({
            text: selectedItem.text,
            value: item,
            index: index,
        }, true)
    }

    getItems = () => this.props.prop.values.items;

    render() {
        let {value, label} = this.props;

        let values = value || [];
        if (!Array.isArray(values))
            values = [values];

        let items = this.getItems().filter(i => {
            return !values.includes(i.value)
        });

        return (
            <div className="filters-panel-input">
                <span title={label}>{label}</span>
                <span>
                    <FieldSelectAutoComplete
                        items={items}
                        value={values}
                        forceReadable={true}
                        forceNonPortal={true}
                        onChange={(e) => this.onChange(e)}
                    />
                </span>
            </div>
        )
    }

}